import styled, { css } from 'styled-components';
import { rem } from '../../utils';
export const StyledWrapper = styled.div `
  display: flex;
  width: 100%;

  flex-direction: column-reverse;
  align-items: center;

  ${({ theme }) => css `
    padding: ${rem(theme.Spacing.Size.XSmall)};
    gap: ${rem(theme.Spacing.Size.XSmall)};
    border-radius: ${rem(theme.Border.Radius.Small)};
    box-shadow: inset 0 0 0 ${rem(theme.Border.Size.Small)}
      ${theme.Color.Neutrals.Border};
    transition: box-shadow ${theme.Transition.Timing.Out};
    cursor: pointer;

    &:hover {
      box-shadow: inset 0 0 0 ${rem(theme.Border.Size.Medium)}
        ${theme.Color.Brand.Primary};
      transition: box-shadow ${theme.Transition.Timing.In};
      .shuffleIndicator {
        opacity: 1;
      }
    }
  `}
`;
export const StyledListWrapper = styled.div `
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: flex-start;
  width: 100%;
  overflow: hidden;
  position: relative;

  ${({ theme }) => css `
    border: ${rem(theme.Border.Size.Small)} solid ${theme.Color.Neutrals.Border};
    border-radius: ${rem(theme.Border.Radius.Small)};

    .color-bullet-wrapper {
      flex: 1;
      width: 0; // To make the color bullet take the remaining space
    }
    .color-bullet {
      width: 100%;
    }
  `}
`;
export const StyledPaletteGroup = styled.div `
  display: flex;
  width: 100%;
`;
export const StyledPaletteLabel = styled.div `
  display: flex;
  width: 100%;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
`;
export const StyledShuffleHover = styled.div `
  position: absolute;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
  opacity: 0;
  transition: opacity ${({ theme }) => theme.Transition.Timing.Out};
`;
//# sourceMappingURL=ColorPalette.style.js.map